import { useEffect, useState } from "react";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const IndustryProfiles = () => {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchProfiles = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/marketplace/industry/profiles/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });

        setProfiles(res.data || []);
      } catch (error) {
        console.error("Error fetching industry profiles:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProfiles();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-10 text-gray-500">
        Loading industry profiles...
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto p-4">
      <h2 className="text-xl font-semibold mb-4">Industry Profiles</h2>

      <div className="flex flex-col gap-3">
        {profiles.map((profile, index) => (
          <div
            key={profile.id || index}
            className="flex items-center justify-between bg-white p-3 rounded-xl shadow-sm"
          >
            {/* LEFT SIDE */}
            <div className="flex items-center gap-4">
              {/* Logo Circle */}
              <div className="w-16 h-16 rounded-full bg-gray-100 p-[2px]">
                <img
                  src={profile?.industry_logo}
                  alt={profile?.industry_name}
                  className="w-full h-full rounded-full object-cover"
                />
              </div>

              {/* Info */}
              <div>
                <p className="font-medium text-sm">
                  {profile.industry_name}
                </p>

                <p className="text-gray-500 text-xs">
                  {profile.contact}
                </p>

                <p className="text-gray-400 text-[11px]">
                  {profile.address?.slice(0, 40)}...
                </p>
              </div>
            </div>

            {/* BUTTON */}
            <button className="text-xs px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">
              Collaborate
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IndustryProfiles;